var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wizardstep-jobmatch-jobtitles" }, [
    _c(
      "div",
      { staticClass: "job-titles-container" },
      [
        _c(
          "div",
          {
            staticClass:
              "input-container d-flex flex-column align-items-center mb-5",
          },
          [
            _c("b-form-textarea", {
              staticClass: "mb-2",
              attrs: {
                placeholder: _vm.wizardstep.jobTitlesTextareaPlaceholder,
                rows: "3",
                "no-resize": "",
              },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.findJobtitles.apply(null, arguments)
                },
                input: function ($event) {
                  return _vm.inputChanged()
                },
              },
              model: {
                value: _vm.input,
                callback: function ($$v) {
                  _vm.input = $$v
                },
                expression: "input",
              },
            }),
            _c(
              "b-btn",
              {
                staticClass: "btn-light",
                attrs: { disabled: _vm.input.length <= 0 },
                on: { click: _vm.findJobtitles },
              },
              [
                _vm.gettingJobMatches === true
                  ? _c("b-spinner", {
                      staticClass: "mr-2",
                      attrs: { small: "", type: "grow" },
                    })
                  : _vm._e(),
                _c("span", [
                  _vm._v(_vm._s(_vm.wizardstep.jobTitlesButtonText)),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm.occupations !== _vm.undefiend && _vm.occupations.length > 0
          ? [
              _vm.gettingJobMatches === false &&
              _vm.wizardstep.jobTitleResultHeader !== ""
                ? _c("h6", { staticClass: "fw-fat mb-4 d-flex" }, [
                    _vm._v(_vm._s(_vm.wizardstep.jobTitleResultHeader)),
                  ])
                : _vm._e(),
              _vm._l(_vm.occupations, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "items" },
                  [
                    item !== undefined
                      ? _c("OccupationListItem", {
                          attrs: { item: item, source: "AISuggested" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ]
          : _c("div", { staticClass: "no-job-titles mt-4" }, [
              _vm.wizardstep.jobTitlesTextExamples !== undefined &&
              _vm.wizardstep.jobTitlesTextExamples !== null &&
              _vm.wizardstep.jobTitlesTextExamples.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "examples mt-4 d-flex flex-column align-items-center",
                    },
                    [
                      _c("b-icon", {
                        staticClass: "mb-2",
                        attrs: { icon: "chat-dots", "font-scale": "1.2" },
                      }),
                      _vm.wizardstep.jobTitlesListHeader !== undefined
                        ? _c("p", { staticClass: "fw-fat" }, [
                            _vm._v(_vm._s(_vm.wizardstep.jobTitlesListHeader)),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "small-line my-1" }),
                      _c(
                        "div",
                        { staticClass: "row mt-2 justify-content-center" },
                        _vm._l(
                          _vm.wizardstep.jobTitlesTextExamples,
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "example-item col-12 col-sm-4 col-md p-2 border rounded m-1 text-center",
                              },
                              [_vm._v("“" + _vm._s(item) + "”")]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }